module.exports = __webpack_public_path__ + "static/media/ver1.2b4f7264.png";